import { AuthLayout } from '@/components/auth/AuthLayout';
import { EmblemShowcase } from '@/components/auth/EmblemShowcase';
import { SignupForm } from './components/SignupForm';

export const Signup = () => {
  return (
    <AuthLayout
      form={<SignupForm />}
      showcase={
        <EmblemShowcase
          eyebrow="PROVISION"
          title="Built around your network. Not the other way around."
          subtitle="One agent install, one camera, full AI pipeline. Bring any RTSP camera."
          bullets={[
            'Free tier — one camera, one agent',
            'Any RTSP camera, no proprietary hardware',
            'Tenants isolated by default',
          ]}
        />
      }
    />
  );
};
